import { severityStyleForTier } from "./assetUtils";

// Manually-set risk levels for the Zones feature — same tiers as CVE severity so
// the two risk concepts (asset-level CVE risk vs manually-assessed zone risk)
// share a consistent color language across the UI.
export const ZONE_RISK_LEVELS = ["none", "verylow", "low", "medium", "high", "critical"];

// severityStyleForTier's "none" label ("Unknown") fits CVE context, not a
// manually-chosen "no risk set" zone — override just that one label here.
export const zoneRiskLabel = (risk) => (risk === "none" ? "-" : severityStyleForTier(risk).label);

export { severityStyleForTier as zoneRiskStyle };
